module.exports = __webpack_public_path__ + "img/twcnvag.304d5cd1.png";